module.exports = __webpack_public_path__ + "img/newsletter.b8f2bc29.svg";